import { onSearchTab } from "../../utilities";

export const searchTabProp = (searchTab, link, onClick) => ({
  onClick: () => onSearchTab(searchTab, link, onClick)
});
